import React from 'react';
import PropTypes from 'prop-types';
import isRequiredIf from 'react-proptype-conditional-require';
import { connect } from 'react-redux';

import { getMGMDetails } from '../../selectors/mgmSelectors';
import { closeInviteModal } from '../../actions/inviteActions';
import { trackInvitedFriends, trackShowRoovitePrompt } from '../../actions/tracking/sharing';
import i18n from '../../utils/i18n';
import InviteModal from '../../components/InviteModal';

export function InviteModalContainer({
  isOpen,
  onClose,
  referrerAmount,
  inviteeAmount,
  referralHref,
  referralLink,
  referralCode,
  referrerSteps,
  inviteeSteps,
  creditExpiry,
  trackInviteSent,
  trackInviteModalShown,
  minimumOrderValue,
}) {
  let props = {
    isOpen,
    onClose,
    referralHref,
    referralLink,
    referralCode,
    trackInviteSent,
    trackInviteModalShown,
    referrerAmount,
    inviteeAmount,
    copyLabel: i18n.gettext('mgm.invite.modal.inviteLink.label.copy'),
    copiedLabel: i18n.gettext('mgm.invite.modal.inviteLink.label.copied'),
  };

  if (referrerSteps && inviteeSteps) {
    props = {
      ...props,
      headerTitle: i18n.gettext('mgm.inviteStepped.modal.modalTitle(%(referrerAmount)s)', {
        referrerAmount,
      }),
      bodyHeading: i18n.gettext('mgm.inviteStepped.modal.bodyHeading'),
      bodyText: i18n.gettext(
        'mgm.inviteStepped.modal.bodyText(%(referrerAmount)s, %(referrerSteps)s, %(inviteeAmount)s, %(inviteeSteps)s)',
        {
          referrerAmount,
          referrerSteps,
          inviteeAmount,
          inviteeSteps,
        },
      ),
      inviteLinkDescription: i18n.gettext(
        'mgm.inviteStepped.modal.inviteLink.description(%(creditExpiry)s, %(minimumOrderValue)s)',
        { creditExpiry, minimumOrderValue },
      ),
      shareTextEmailSubject: i18n.gettext(
        'mgm.inviteStepped.modal.share.email.subject(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
      shareTextEmailBody: i18n.gettext(
        'mgm.inviteStepped.modal.share.email.body(%(inviteeAmount)s, %(shareLink)s)',
        {
          inviteeAmount,
          shareLink: referralHref,
        },
      ),
      shareTextTwitter: i18n.gettext(
        'mgm.inviteStepped.modal.share.twitter.tweetText(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
      shareTextFacebook: i18n.gettext(
        'mgm.inviteStepped.modal.share.facebook.shareText(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
    };
  } else {
    props = {
      ...props,
      headerTitle: i18n.gettext('mgm.invite.modal.modalTitle(%(referrerAmount)s)', {
        referrerAmount,
      }),
      bodyHeading: i18n.gettext('mgm.invite.modal.bodyHeading'),
      bodyText: i18n.gettext('mgm.invite.modal.bodyText(%(referrerAmount)s, %(inviteeAmount)s)', {
        referrerAmount,
        inviteeAmount,
      }),
      inviteLinkDescription: i18n.gettext('mgm.invite.modal.inviteLink.description'),
      shareTextEmailSubject: i18n.gettext(
        'mgm.invite.modal.share.email.subject(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
      shareTextEmailBody: i18n.gettext(
        'mgm.invite.modal.share.email.body(%(inviteeAmount)s, %(shareLink)s)',
        {
          inviteeAmount,
          shareLink: referralHref,
        },
      ),
      shareTextTwitter: i18n.gettext(
        'mgm.invite.modal.share.twitter.tweetText(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
      shareTextFacebook: i18n.gettext(
        'mgm.invite.modal.share.facebook.shareText(%(inviteeAmount)s)',
        {
          inviteeAmount,
        },
      ),
    };
  }

  return <InviteModal {...props} />;
}

InviteModalContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  trackInviteSent: PropTypes.func.isRequired,
  trackInviteModalShown: PropTypes.func.isRequired,
  referrerAmount: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  inviteeAmount: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referralHref: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referralLink: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referralCode: isRequiredIf(PropTypes.string, (props) => props.isOpen),
  referrerSteps: isRequiredIf(PropTypes.number, (props) => props.isOpen),
  inviteeSteps: isRequiredIf(PropTypes.number, (props) => props.isOpen),
  creditExpiry: isRequiredIf(PropTypes.number, (props) => props.isOpen),
  minimumOrderValue: isRequiredIf(PropTypes.string, (props) => props.isOpen),
};

InviteModalContainer.defaultProps = {
  referrerAmount: undefined,
  inviteeAmount: undefined,
  referralHref: undefined,
  referralLink: undefined,
  referralCode: undefined,
  referrerSteps: undefined,
  inviteeSteps: undefined,
  creditExpiry: undefined,
  minimumOrderValue: undefined,
};

const mapStateToProps = (state) => {
  const {
    referrerAmount,
    inviteeAmount,
    referralHref,
    referralLink,
    referralCode,
    referrerSteps,
    inviteeSteps,
    creditExpiry,
    minimumOrderValue,
  } = getMGMDetails(state);

  return {
    isOpen: state.user.roovite.showModal,
    referrerAmount,
    inviteeAmount,
    referralHref,
    referralLink,
    referralCode,
    referrerSteps,
    inviteeSteps,
    creditExpiry,
    minimumOrderValue,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeInviteModal()),
  trackInviteSent: (method) => dispatch(trackInvitedFriends(method)),
  trackInviteModalShown: (options) => dispatch(trackShowRoovitePrompt(options)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InviteModalContainer);
